import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [RouterModule.forRoot([
        { path: '', redirectTo: 'home', pathMatch: 'full' },
        { path: 'login', loadChildren: './login/login.module#LoginModule' },
        { path: 'access-denied', loadChildren: './components/access-denied/access-denied.module#AccessDeniedModule' },
        { path: 'versions-not-compatible', loadChildren: './components/versions-not-compatible/versions-not-compatible.module#VersionsNotCompatibleModule' },
        { path: 'home', loadChildren: './home/home.module#HomeModule' },
        { path: 'orders', loadChildren: './orders/orders.module#OrdersModule' },
        // { path: 'marketingpurchases', loadChildren: './marketing-purchases/marketing-purchases.module#MarketingPurchasesModule' },
        { path: 'item-properties', loadChildren: './item-properties/item-properties.module#ItemPropertiesModule' },
        { path: 'buffertable', loadChildren: './buffer-table/buffer-table.module#BufferTableModule' },
        { path: 'marketing-purchase', loadChildren: './marketing-purchase/marketing-purchase.module#MarketingPurchaseModule' },
        { path: 'changebuffer', loadChildren: './change-buffer/change-buffer.module#ChangeBufferModule' },
        { path: 'importassortment', loadChildren: './import-assortment/import-assortment.module#ImportAssortmentModule' },
        { path: 'stocks', loadChildren: './stocks/stocks.module#StocksModule' },
        { path: 'schedules', loadChildren: './supply-schedules/supply-schedules.module#SupplySchedulesModule' },
        { path: 'vacations', loadChildren: './vacations/vacations.module#VacationsModule' },
        { path: 'manual-orders', loadChildren: './manual-orders/manual-orders.module#ManualOrdersModule' },
        { path: 'test', loadChildren: './test/testing.module#TestingModule' },
        { path: 'buffer-graph', loadChildren: './buffer-graph/buffer-graph.module#BufferGraphModule' },
        { path: '**', redirectTo: 'home' }
    ])
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {

}




// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts